import script from "./ProfileEducation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEducation.vue?vue&type=script&setup=true&lang=js"

import "./ProfileEducation.vue?vue&type=style&index=0&id=96370c5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96370c5e"]])

export default __exports__